import React from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { disableCustomerServiceContact } from './ContactPage';

type InfoboxProps = {
  endpoint: string;
};

const Infobox: React.FunctionComponent<InfoboxProps> = (props: InfoboxProps) => {
  const { endpoint } = props;
  const { t } = useTranslation();

  if (disableCustomerServiceContact) {
    return (
      <div className="col-9">
        <h1 className="h2" aria-live="polite">
          {t(`customerService:contactUs.oomi.contactTitle`)}
        </h1>
        <p>
          <Trans i18nKey="customerService:contactUs.oomi.contactUsParagraphOne">
            .
            <a href="https://oomi.fi/asiakaspalvelu/yhteystiedot" target="_blank" rel="noopener noreferrer"></a>
            <a href="https://oomi.fi/yhteydenotto" target="_blank" rel="noopener noreferrer"></a>
          </Trans>
        </p>
        <p>
          <Trans i18nKey="customerService:contactUs.oomi.contactUsParagraphTwo">
            .
            <a href="https://www.lumme-energia.fi/oomi" target="_blank" rel="noopener noreferrer"></a>
          </Trans>
        </p>
      </div>
    );
  }

  return (
    <div className="col-9">
      <h1 className="h2" aria-live="polite">
        {t(`customerService:contactUs.contactTitle`)}
      </h1>
      <p> {t(`customerService:contactUs.${endpoint}.contactUsParagraphOne`)} </p>
      <p> {t(`customerService:contactUs.${endpoint}.contactUsParagraphTwo`)} </p>
      <p> {t(`customerService:contactUs.${endpoint}.contactUsParagraphThree`)} </p>
    </div>
  );
};
export default Infobox;
